module.exports = __webpack_public_path__ + "img/xjkh.a581d4a2.png";